<script>
  import {createEventDispatcher, getContext, onMount} from 'svelte';
  import {LINKS} from '@/const/link';
  import {PATHS} from '@/const/paths';
  import {sd} from '@/da';
  import {fixLink$} from '@/store/lang';
  import {isSupportPilotContract$} from '@/streams/accounts';
  import MenuItemView from '../components/MenuItemView.svelte';
  import lang from '../../Header.lang';
  import {FETURES_CATEGORY} from '@/modules/header/const';
  import Menu from '@/widgets/trigger/Menu.svelte';
  import ContractMarketDropDown from './ContractMarketDropDown.svelte';

  const LG = getContext('LG');
  const excludeMenu = [FETURES_CATEGORY.USDT, FETURES_CATEGORY.COIN, FETURES_CATEGORY.PILOT];

  const dispatch = createEventDispatcher();

  const modifiers = [
    {
      name: 'flip',
      enabled: false, // 禁用 flip 修饰符，防止自动调整位置
    },
    {
      name: 'offset',
      options: {
        offset: [0, 0],
      },
    },
    {
      name: 'preventOverflow',
      options: {
        padding: 0,
      },
    },
  ];

  let menus = [];
  let hasSubSet = false;
  let innerHeight;
  let componentRef;

  $: updateMenu(LG, $isSupportPilotContract$);

  onMount(() => {
    innerHeight = componentRef.getBoundingClientRect().height;
  });

  function updateMenu(LG, isSupportPilotContract) {
    menus = [
      {
        iconUrl: 'https://img.phemex.com/v1/61bcd4c7-0baf-449f-98c6-49108bbf68f8/property-1-usdt-m.svg',
        iconAlt: 'USDT-M Perpetual',
        title: `USDT-M ${LG(lang.Perpetual)}`,
        subTitle: LG(lang.PerpetualContractUSDC),
        link: $fixLink$(LINKS.PHEMEX_CONTRACT_TRADE_USDS),
        target: '_self',
        name: 'usdt_m_perpetual',
        categoryId: 'PositiveUsds',
      },
      {
        iconUrl: 'https://img.phemex.com/v1/6e6cc87b-5adf-44db-8126-7e1135f9704e/property-1-coin-m.svg',
        iconAlt: 'COIN-M Perpetual',
        title: `COIN-M ${LG(lang.Perpetual)}`,
        subTitle: LG(lang.PerpetualContractCoin),
        link: $fixLink$(LINKS.PHEMEX_CONTRACT_INVERSE_TRADE),
        target: '_self',
        name: 'coin_m_perpetual',
        categoryId: 'Inverse',
      },
      isSupportPilotContract
        ? {
            iconUrl: 'https://img.phemex.com/v1/2f50faae-cb94-4e8b-8671-a869f88681bd/property-1-pilot.svg',
            iconAlt: 'Pilot',
            title: LG(lang.Pilot),
            subTitle: LG(lang.PilotContractDesc),
            link: $fixLink$(LINKS.PHEMEX_PILOT_CONTRACT_TRADE),
            target: '_self',
            name: 'pilot_contract',
            titleIcon: 'https://img.phemex.com/v1/c80564dc-92f8-4e33-bcd6-a9e383b8857d/new.svg',
            categoryId: '',
          }
        : null,
      {
        iconUrl: 'https://img.phemex.com/v1/869a3e59-e45e-44d7-9ca1-73c76a75d399/property-1-copy-trade.svg',
        iconAlt: 'copy trade',
        title: LG(lang.CopyTrade),
        subTitle: LG(lang.FollowTop),
        link: $fixLink$(PATHS.COPY_TRADING_LIST.pathname),
        target: '_self',
        name: 'copy_trade',
      },
      {
        iconUrl: 'https://img.phemex.com/v1/a9897121-4e55-4d97-90a0-696917055b44/property-1-trading-bots.svg',
        iconAlt: 'strategy square',
        title: LG(lang.TradingBots),
        subTitle: LG(lang.IntelligentTrading),
        link: $fixLink$(PATHS.STRATEGY_SQUARE.pathname) + '?type=CONTRACT_GRID',
        target: '_self',
        name: 'trading_bots',
      },
      {
        iconUrl: 'https://img.phemex.com/v1/bc122659-2206-4b74-9df8-efdc0c67d03c/property-1-leaderboard.svg',
        iconAlt: 'leaderboard',
        title: LG(lang.Leaderboard),
        subTitle: LG(lang.LeaderboardDesc),
        link: $fixLink$(PATHS.CONTRACT_LEADERBOARD.pathname),
        target: '_self',
        name: 'leaderboard',
      },
      {
        iconUrl: 'https://img.phemex.com/v1/77a31687-34bb-4cb9-8a63-ed984f28f619/property-1-simulate-trading.svg',
        iconAlt: 'mock trading',
        title: LG(lang.MockTrading),
        subTitle: LG(lang.LearnHowToTradeWithZeroRisk),
        link: $fixLink$(LINKS.MOCK_TRADE),
        target: '_self',
        name: 'mock_trading',
      },
    ].filter(Boolean);
  }
  function handleContractClickFuc(item) {
    return function () {
      sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_contract_' + item});
    };
  }

  function handleMouseEnterForNext(menuName) {
    // 删除默认active状态
    if (menuName !== FETURES_CATEGORY.USDT) {
      const elem = document.querySelector(`.contract-menu-usdt`);
      elem.classList.remove('active');
    }
    hasSubSet = excludeMenu.includes(menuName);
    dispatch('hover', hasSubSet);
  }

  function handleMouseLevel(e) {
    if (e.target.classList.contains('contract-group') || e.target.classList.contains('common-item-wrap')) {
      hasSubSet = false;
    }
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    width: 328px;
    cursor: default;
    backdrop-filter: blur(10px);
  }
  .wrap-subset {
    border-bottom-right-radius: 12px;
    padding-right: 344px;
    width: 672px;
  }
  .wrap .contract-group {
    padding-bottom: 16px;
    background: rgba(26, 29, 31, 0.96);
  }
  .contract-market-menu {
    width: 100%;
  }
  :global(.contract-menu-usdt.active .menu-item) {
    background: rgba(255, 255, 255, 0.06);
  }
</style>

<div class="wrap df fdc ovh T2" class:wrap-subset={hasSubSet} bind:this={componentRef}>
  <div class="contract-group df fdc" on:mouseover={handleMouseLevel}>
    {#each menus as menu}
      {#if [FETURES_CATEGORY.USDT, FETURES_CATEGORY.COIN, FETURES_CATEGORY.PILOT].includes(menu.name)}
        <Menu class="contract-market-menu" triggerClass="contract-menu-usdt" duration={0} placement="right-start" {modifiers} noIcon on:mouseenter={handleMouseEnterForNext.bind(null, menu.name)}>
          <div slot="trigger" class="f1 wp100 ph16 ovh" class:pt16={menu.name === FETURES_CATEGORY.USDT}>
            <MenuItemView {...menu} theme="dark" noArrowHover on:click={handleContractClickFuc(menu.name)} />
          </div>
          <ContractMarketDropDown name={menu.name} categoryId={menu.categoryId} {innerHeight} />
        </Menu>
      {:else}
        <div class="ph16 common-item-wrap">
          <MenuItemView {...menu} theme="dark" on:click={handleContractClickFuc(menu.name)} on:mouseenter={handleMouseEnterForNext} noArrow />
        </div>
      {/if}
    {/each}
  </div>
</div>
